<template lang="pug">
  v-container(fill-height)
    v-layout(row, wrap, align-center)
      v-flex(md6, offset-md3)

        v-card
          v-card-title(primary-title='')
            h3.headline.mb-0 Sign In
          v-card-text
            v-form
              v-text-field(v-model='C.form.selected.account.email', label='E-mail', required='')
              v-text-field(v-model='C.form.selected.account.password', label='Enter your password', type='password', hint='At least 8 characters', min='8', counter='', required='')
          v-card-text 
            v-btn(@click='C.form.trigger.submit', block, large, color='primary') Login
        p.pa-3.text-xs-center
          | Not a member? 
          router-link(to='create-account')
            | Create an account
          |.
</template>

<script>
import axios from '../../../node_modules/axios/dist/axios.js'

export default {
  data () {
    return {
      C: {
        form: {
          selected: {
            account: {
              email: '',
              password: ''
            }
          },
          trigger: {
            submit: () => {
              var component = this

              var submitItem = {
                email: this.C.form.selected.account.email,
                password: this.C.form.selected.account.password
              }

              axios.get(`${process.env.BASE_API_URL}${process.env.BASE_API_VERSION}/users/sign_in`, {
                params: submitItem
              })
              .then(function (response) {
                console.info('Sign In Results: ', response.data)

                component.$router.push({
                  name: 'People'
                })
              })
              .catch(function (errorResponse) {
                console.error('errorResponse', errorResponse)
              })
            }
          }
        }
      }
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Authentication/PasswordSignIn.vue